import { DateTimePicker } from "./TS_Controls";
import { ajaxSettings, extend } from "jquery";
import { ORDRBY } from "./TS_DOCS";

export interface CartCfg {
	Endpoint?: string;

	AppContainer?: string;
	PanelPortalSelector?: string;

	AlertCallback?: (msg: string) => void;
}


export interface DocsCfg {
	Endpoint?: string;

	AppContainer?: string;
	// PanelPortalSelector?: string;

	AlertCallback?: (msg: string) => void;
}





export class Helper {




	public static HasData(input: any): boolean {
		if (input == null || input == undefined || input == "") return false;
		return true;
	}


	public static GetFileExtension(path: string): string {
		if (!this.HasData(path)) return null;

		var io = path.lastIndexOf('.');

		if (io == -1) return null;

		var rval = path.substr(io + 1).toLowerCase();

		return rval;
	}


	
	public static IsSupportedExtension(path: string, formats: string[]): boolean 
	{
		var ext =  Helper.GetFileExtension(path);

		if (!ext) return false;

		var isIt = formats.indexOf(ext) > -1;
		return isIt;
	}
	
	


	public static GetFilenameWithoutExtension(path: string): string
	 {
		if (!path) return null;
		var io = path.lastIndexOf('.');
		if (io == -1) return null;
		var rval = path.substr(0, io);
		return rval;
	}




	public static Sanitize(input: string): string
	{
		if (!input) return null;

		var r1 = new RegExp(/[^a-zA-Z0-9_]/g);
		var r2 = new RegExp(/_{2,}/g);

		input = input.replace(r1, "_");
		input = input.replace(r2, "_");

		return input;
	}

	




	/// BORROWED FROM HERE: https://www.c-sharpcorner.com/blogs/generate-guid-using-javascript1
	/// THERE ARE OTHER WAYS TO CREATE GUIDS WITH JS.
	public static CreateGuid(): string {
		var rval = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});

		return rval;
	}



}






export class ResponseBase {
	public Ok: boolean;
	public Msg: string;
}


export interface AjaxStdResponse {
	Ok: boolean;
	Msg?: string;
}


export interface GetCsvResponse extends AjaxStdResponse {
	Code: string;
}


export interface BatchGenerationRequest{
	ClientName: string;
	Emails: string;
}

export interface BatchGenerationResponse extends AjaxStdResponse{
	Code: string;
}





export interface LoadRequest {
	// Filter?: WhatFilter;
	Filters?: boolean[];
	Page?: number;
	PageSize?: number;
	Sort?: SortInfo;
	SearchString?: string;
	ClassOrProgram?: string;
	SimpleDateRange?: string;
}

export interface LoadResponse extends AjaxStdResponse {
	// Orders?: OrderDTO[];
	Compos?: SuperCompoDTO[];
	Company?: CompanyDTO;
	// DefaultFilter?: WhatFilter;
	Filters?: boolean[];
	PageInfo?: PageInfo;
	Sort?: SortInfo;
	SearchString: string;
	ClassOrPrograms: string[];
	ChildOrgs: string[];
	StudentNotesRead: StudentNoteReadDTO[];
	IsViewpointAdmin: boolean;
	CanUploadOnBehalf: boolean;
	SimpleDateRange?: string;
}



export interface CompanyDTO {
	RecordID?: number;
	Name?: string;
	RealName?: string;
	Classifications?: ClassifDto[];
	ShareableWith?: ShareDto[];
	HealthPortal?: boolean;
	HealthBio?: boolean;
	Email?: string;
}


export interface ShareDto {
	Name?: string;
}



export interface ClassifDto {
	Name?: string;
}


// export interface OrderDTO {
//   ID: number;
//   ClientName: string;
//   Email: string;
//   IsArchived: boolean;
//   Name: string;
//   Status: OrderStatus;
//   DatePlaced: Date;
//   DOB: Date;
//   SSN: string;
//   Classification: string;
//   IsApproved: boolean;
//   SharedWith?: string;
// }


// export interface OrderCompoDTO {
//   Contact: ContactDTO;
//   Order: OrderDTO;
//   Files: RequirementFileDTO[];
//   PdfDocument: string;
// }



export interface SuperCompoDTO {
	HealthPortalStatus: FileFlag;
	Person: PersonInfo;
	HealthPortalIsNew: boolean;
}



export enum FileFlag {
	NoFiles = 10,
	SomeFilesNotApproved = 20,
	AllFilesApproved = 30,
	FilesPending = 40,
	NoHealthPortal = 50,
}



export interface FileMessage {
	Date?: Date;
	Msg?: string;
}



export interface PersonInfo {
	ContactID?: number;
	DOB?: Date;
	Email?: string;
	FName?: string;
	LName?: string;
	SSN?: string;
	Tests?: TestOrdered[];
	Classification?: string;
	SharedWith?: string;
	IsArchived?: boolean;
	IsApproved?: boolean;
	// DatePlaced?: Date;
	OrderID?: number;
}



export interface TestOrdered {
	DatePlaced?: Date;
	OrderID?: number;
	Status?: OrderStatus;
	TestName?: string;
	PdfDocument?: string;
	IsNew?: boolean;
}





export interface ContactDTO {
	ID: number;
	Name: string;
	Email: string;
}

export interface RequirementFileDTO {
	ClientName: string;
	ID: number;
	ContactID?: number;
	ReqName: string;
	Status: FileStatus;
	Path: string;
	IsNew: boolean;
	StatusDate?: Date;
	ExpiryDate?: Date;
	Vaccines: VaccineDateDto[];
}


export enum OrderStatus {
	Approved = 10,
	NotApproved = 20,
	Pending = 30,
	Processing = 40,
	Denied = 50,
	Tracker = 0
}



export enum FileStatus {
	Approved = 10,
	NotApproved = 20,
	Pending = 30,
	SeriesInProcess = 35,
	NotUploaded = 40,
	ApprovalPending = 50,
	Unknown = 0
}




export enum FileSubStatus {
	Unspecified = 0,
	ApprovedAdmin = 10,
	ApprovedWaiver = 20,
	ApprovedExemption = 30,
	ApprovedTiter = 40,
	ApprovedVaccines = 50,
	Inactive = 60,
	NotApprovedAdmin = 70,
	NotApprovedExpired = 80,
	NotApprovedNoNameVisible = 90,
}


export class FileStatusDefinition {
	public Status: FileStatus;
	public StatusName: string;
	public SubStatus: FileSubStatus[];
}





export class ToggleDTO {
	Approve: boolean = false;
	Archive: boolean = false;
	Classify: boolean = false;
	Share: boolean = false;
}







export enum WhatToggle {
	Approve = 0,
	Archive = 1,
	Classify = 2,
	Share = 3,
	Unapprove = 4,
	Unarchive = 5,
}




export interface MarkAllRequest {
	IDs?: number[];
	What?: WhatToggle;
	Classif?: ClassifDto;
	ShareWith?: ShareDto;
}

export interface MarkAllResponse extends AjaxStdResponse {
}


export interface SetReadRequest {
	// File?: RequirementFileDTO;
	RecordID: number;
}


export interface SetReadResponse extends AjaxStdResponse {
}


export interface SendMessageRequest {
	UserID?: number;
	UserEmail?: string;
	// SenderEmail?: string;
	Message?: string;
}


export interface SendMessageResponse extends AjaxStdResponse {
}


export interface GetMessagesRequest {
	UserID?: number;
}


export interface GetMessagesResponse extends AjaxStdResponse {
	Messages: FileMessage[];
}




export interface GetFilesRequest {
	ReferenceOrderID?: number;
}




export enum LoggieType {
	Info = 0,
	Ok = 1,
	Error = 13
}

export interface Loggie {
	Type: LoggieType;
	Message: string;
	Date: Date;
	Test: string;
}


export interface GetFilesResponse extends AjaxStdResponse {
	Files: RequirementFileDTO[];
	ApprovalLogs: Loggie[]
	Requirements: RequirementFileDTO[];
}




export interface UpdateFileRequest {
	File?: RequirementFileDTO;
	NewFileStatus?: FileStatus;
	ExpDate?: string;
	UpdateExpDate?: boolean;
	PersonEmail?: string;
	RequestMessage: string;
}


export interface UpdateFileResponse extends AjaxStdResponse {
	File?: RequirementFileDTO;
}



export interface StudentNoteReadDTO {
	StudentID: number;
	CompanyID: number;
	LatestNoteId: number;
	ReaderID: number;
	LatestNoteRead?: number;
	AreNewNotes: boolean;
}





export interface StudentFileDTO {
	RecordID?: number;
	Name?: string;
	Path?: string;
}


export interface StudentNoteDTO {
	RecordID: number;
	CompanyID: number;
	StudentID: number;
	Notes: string;
	CreatedBy: number;
	CreatedByFName: string;
	CreatedByLName: string;
	CreatedOn: Date;
	Files: string[];
}

export interface LoadStudentNotesRequest {
	StudentID?: number;
}

export interface LoadStudentNotesResponse extends AjaxStdResponse {
	Notes: StudentNoteDTO[];
}



export interface InsertStudentNoteRequest {
	StudentID?: number;
	Note: string;
	FilePath: string;
	Files: any[];
}

export interface InsertStudentNoteResponse extends AjaxStdResponse {
	Note: StudentNoteDTO;
}




export interface DeleteStudentNoteRequest {
	NoteID?: number;
}

export interface DeleteStudentNoteResponse extends AjaxStdResponse {
}

export interface DeleteStudentNoteFileRequest {
	FileID?: number;
}

export interface DeleteStudentNoteFileResponse extends AjaxStdResponse {
}




export interface BadgeDTO {
	OrderID: number;
}


export enum WhatFilter {
	New = 0,
	Approved = 1,
	Current = 2,
	Archived = 3,
	Completed = 4,
	InProcess = 5,
	Clear = 6,
	Hits = 7,
	Compliant = 8,
	NotCompliant = 9,
}


export enum SortBy {
	DataOptions = 10,
	Name = 20,
	NameInv = 25,
	Classif = 30,
	OrderDate = 40,
	OrderInfo = 50,
	ClinicalSite = 60,
}




export interface PageInfo {
	Total?: number;
	Current?: number;
	RPP?: number;
}


export interface SortInfo {
	SortBy: SortBy;
	SortAsc: boolean;
}





export class CookieMan {


	public static SetCookie(name: string, value: string, days?: number): void {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}

	public static GetCookie(name: string): string {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	public static EraseCookie(name: string): void {
		document.cookie = name + '=; Max-Age=-99999999;';
	}



}






export interface LoadDocsRequest {

}
export interface LoadDocsResponse extends AjaxStdResponse {
	StatusValues: string[];
	Orgs: string[];
	StatusDefinitions: FileStatusDefinition[];
}


export interface SearchDocsRequest {
	SearchKey: string;
	Page?: number;
	PageSize?: number;
	StatusFilter: string;
	OrgFilter: string;
	OrderBy?: ORDRBY;
	UploadedAfter: string,
	UploadedBefore: string,

	FileStatusFilter?: number;
	FileSubStatusFilter?: number;
}


export interface SearchDocsResponse extends AjaxStdResponse {
	Results: DocDTO[];
	TotalRecords: number;
	MaxPage: number;
}



export interface DirectFileModRequest {
	NewFileStatus: FileStatus;
	NewFileSubStatus: FileSubStatus;
	FileID: number;
	NewExpDate?: Date;
	RejectReason: string;
	StudentMessage: string;
}


export interface DirectFileModResponse extends AjaxStdResponse {
	UpdatedFile: DocDTO;
}

export class DocDTO {
	public RecordID: number;
	public Student: string;
	public TestName: string;
	public Path: string;
	public Organization: string;
	public Status: string;
	public Status2: FileStatus;
	public SubStatus: FileSubStatus;
	public Date?: Date;
	public ExpDate?: Date;
	public DateUpdated?: Date;

	public Vaccines: VaccineDateDto[] = [];
}




export enum VacDateType {
	Vaccine = 0,
	Titer = 10,
}


export class VaccineDateDto {
	public RecordID: number;
	public TestID: number;
	public StudentID: number;
	public DateType: VacDateType;
	public Date: Date;
	public Message: string;
	public Manufacturer: string;
}


export interface InsertVacDateRequest {
	VacDate: VaccineDateDto;
}

export interface InsertVacDateResponse extends AjaxStdResponse {
	VacDate: VaccineDateDto;
}

export interface DeleteVacDateRequest {
	RecordID: number;
}

export interface DeleteVacDateResponse extends AjaxStdResponse {
}


export interface LoadVacDateRequest {
	TestID: number;
}

export interface LoadVacDateResponse extends AjaxStdResponse {
	VacDates: VaccineDateDto[];
}



export interface LoadVacAndMessagesRequest {
	TestID: number;
}

export interface LoadVacAndMessagesResponse extends AjaxStdResponse {
	VacDates: VaccineDateDto[];
	Messages: FileMessage[];
	RequirementInfo: any;
	Logs: any[];
}


export interface GetLogsRequest {
	ObjectID: number;
}

export interface GetLogsResponse extends AjaxStdResponse {
	Logs: ActionTrackDTO[];
}


export interface ActionTrackDTO{
	RecordID: number;
	UserID: number;
	UserName: string;
	ActionDate: Date;
	ObjectID: number;
	ObjectType: any;
	Descr: string;
	FullPayload: string;

}




// WEBPACK FOOTER //
// ./js/TS_Classes.ts